import React, { useContext, useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import { handleApiErrors } from "../../Utils/Utils";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import { toast } from "react-toastify";
import ViewModal from "../../Components/modal/ViewModal";
import DynamicService from "../../Services/DynamicService";
import * as XLSX from "xlsx";
import { AuthContext } from "../../Context/authContext";
const ContactList = () => {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [details, setDetails] = useState({});
  const { user } = useContext(AuthContext)

  const fetchData = async () => {
    try {
      const response = await DynamicService.getAllContact(
        offset,
        limit,
        searchQuery || ""
      );
      setData(response.UserData);
      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const deleteSingleContact = async (id) => {
    try {
      await DynamicService.deleteContact([id]);
      toast.success("Contact Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultipleContact = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.contact_id);
          }
        });
      }
      await DynamicService.deleteContact(itemsToDelete);
      toast.success("Contacts Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [offset]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">CONTACT DETAILS LIST</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Contact details List</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <h1 className="black fs-18 fw-600 mb-0">Contact details List</h1>
        <div className="table_title">
          <div className="table_headings mt-2">
            <h1 className="black fs-18 fw-600 mb-0">
              <div
                className="table_delete_icon"
                style={{
                  opacity:
                    data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                    pointerEvents: data?.findIndex((item) => item.isChecked) === -1 ? 'none' : 'auto',
                }}
                onClick={() => {

                  const dynamicPrivilege = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Dynamic"
                  );
                  if (!dynamicPrivilege?.delete) {
                    
                    toast.warning("You don't have permission to delete contacts.");
                    return;
                  }
                  if (!(data.findIndex((item) => item.isChecked) == -1)) {
                    setIsMultipleDelete(true);
                    setShowDeleteModal(true);
                  }
                }}
              >
                <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
              </div>
            </h1>
            <div className="d-flex gap-4 align-items-center ">
              <div className="position-relative ">
                <input
                  type="search"
                  className="search_box search_bar"
                  placeholder="Search details"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                />
                <Image
                  src={SvgImages.search}
                  style={ImageFilters.gray}
                  className="search_icon"
                  alt="Search Icon"
                  height="20px"
                />
              </div>
            </div>
          </div>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table
            className="table mb-0 "
            id="dtHorizontalExample"
            cellSpacing="0"
            width="100%"
          >
            <thead>
              <tr className="table_heading">
                <th scope="col" style={{ width: "5%" }}>
                  <label className="d-flex align-items-center justify-content-center">
                    <input
                      className="cursor-pointer"
                      type="checkbox"
                      style={{ height: "16px", aspectRatio: 1 }}
                      checked={
                        data?.length > 0 &&
                        data?.findIndex((item) => !item.isChecked) == -1
                      }
                      onChange={(value) => {
                        var updatedData = data;
                        updatedData.map((element) => {
                          element.isChecked = value.target.checked;
                        });
                        setData([...updatedData]);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th scope="col" style={{ width: "20%" }}>
                  Sr No.
                </th>
                <th scope="col" style={{ width: "20%" }}>
                  Name
                </th>
                <th scope="col" style={{ width: "30%" }}>
                  Email
                </th>
                <th scope="col" style={{ width: "20%" }}>
                  Message
                </th>
                <th scope="col" style={{ width: "10%" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg_light">
              {data?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        checked={item.isChecked || false}
                        style={{ height: "16px", aspectRatio: 1 }}
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData[index].isChecked =
                            value.target.checked;
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </td>
                  <td>{limit * offset + (index + 1)}</td>
                  <td>{item.contactName}</td>

                  <td>{item.email}</td>

                  <td>
                    <a
                      className="cursor-pointer"
                      onClick={() => {
                        setShowEditModal(true);
                        setDetails(item);
                      }}
                    >
                      View
                    </a>
                  </td>

                  <td>
                    <div className="d-flex gap_8">
                      <a
                        className="delete_icons cursor-pointer"
                        onClick={() => {

                          const dynamicPrivilege = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Dynamic"
                          );
                          if (!dynamicPrivilege?.delete) {
                           
                            toast.warning("You don't have permission to delete contact.");
                            return;
                          }

                          setDeleteId(item.contact_id);
                          setIsMultipleDelete(false);
                          setShowDeleteModal(true);
                        }}
                      >
                        <Image
                          src={SvgImages.deleteIcon}
                          style={ImageFilters.red}
                          data-bs-target="#delete-modal"
                          data-bs-toggle="modal"
                          alt="Delete Icon"
                        />
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>


        </div>
        {generatePaginationFooter(
          availableDataCount,
          limit,
          offset,
          setOffset
        )}


      </div>

      <ViewModal
        showModal={showEditModal}
        setShowModal={setShowEditModal}
        children={
          <table class="table table-bordered">
            <thead>
              <tr className="row">
                <th class="col-3">Name</th>
                <td className="col-9">{details?.contactName}</td>
              </tr>
              <tr className="row">
                <th class="col-3">Email</th>
                <td className="col-9">{details?.email}</td>
              </tr>{" "}
              <tr className="row">
                <th class="col-3">Subject</th>
                <td className="col-9">{details?.subject}</td>
              </tr>{" "}
              <tr className="row">
                <th class="col-3">Message</th>
                <td className="col-9">{details?.message}</td>
              </tr>{" "}
            </thead>
          </table>
        }
      />

      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete Contacts?"
            : "Are you sure want to delete Contact?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete
            ? deleteMultipleContact()
            : deleteSingleContact(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />
    </div>
  );
};

export default ContactList;
